import { productIdFormat } from "@redotech/redo-product-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const DailySalesPoint_ = z.object({
  date: zExt.plainDate(),
  quantity: z.number().int(),
});

export const DailySalesPoint: z.ZodType<DailySalesPoint> = DailySalesPoint_;
export interface DailySalesPoint extends z.infer<typeof DailySalesPoint_> {}

const ProductHistoricalSales_ = z.object({
  productId: productIdFormat.schema,
  sku: z.string(),
  dailySales: z.array(DailySalesPoint),
});

export const ProductHistoricalSales: z.ZodType<ProductHistoricalSales> =
  ProductHistoricalSales_;
export interface ProductHistoricalSales extends z.infer<
  typeof ProductHistoricalSales_
> {}

const ProductSkuMapping_ = z.object({
  productId: productIdFormat.schema,
  sku: z.string(),
});

export const ProductSkuMapping: z.ZodType<ProductSkuMapping> =
  ProductSkuMapping_;
export interface ProductSkuMapping extends z.infer<typeof ProductSkuMapping_> {}

export const getHistoricalSales = {
  name: "getHistoricalSales" as const,
  input: z.object({
    products: z.array(ProductSkuMapping),
    startDate: zExt.plainDate().optional(),
    endDate: zExt.plainDate().optional(),
  }),
  output: z.object({ products: z.array(ProductHistoricalSales) }),
};
